import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/ComingSoon.scss";
import logo from "../assets/logo2.png";
import bgVideo from "../assets/bg-video.mp4"; // Your video file

const ComingSoon: React.FC = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);

    const adminEmail = emailjs.send(
      "service_ylew5z7",
      "template_8aobzz9",
      {
        from_name: formData.name,
        reply_to: formData.email,
        message: formData.message,
        year: new Date().getFullYear(),
        to_admin_email: "erosvisonmodels@gmail.com",
      },
      "E3DeVs5pgEBhATod5"
    );

    const userAutoReply = emailjs.send(
      "service_ylew5z7",
      "template_qx37d17",
      {
        from_name: formData.name,
        user_email: formData.email,
      },
      "E3DeVs5pgEBhATod5"
    );

    Promise.all([adminEmail, userAutoReply])
      .then(() => {
        setSuccess(true);
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        alert("Something went wrong. Please try again.");
      })
      .finally(() => setSending(false));
  };

  return (
    <div className="coming-soon-page">
      <video autoPlay loop muted playsInline className="background-video">
        <source src={bgVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="content-overlay">
        <img src={logo} alt="ErosModels Logo" className="logo" />
        <h1>We're Launching Soon</h1>
        <p>Join our mailing list to be the first to know when we go live.</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Optional message..."
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit" disabled={sending}>
            {sending ? "Sending..." : "Join Waitlist"}
          </button>
        </form>

        {success && (
          <p className="success-msg">
            Thank you! We've received your request. 🎉
          </p>
        )}
      </div>
    </div>
  );
};

export default ComingSoon;